import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";
import NavListItem from "./nav-list-item";

class FloatingHeader extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.scrollToTop  = this.scrollToTop.bind(this);
    this.handleClick  = this.handleClick.bind(this);
    this.onClickLeft  = this.onClickLeft.bind(this);
    this.onClickRight = this.onClickRight.bind(this);



    this.navs = this.props.items.slice();
    this.navs.shift();  // Remove "eventtype"
    this.navs.shift();  // Remove "intro"

    this.firstSlide = 1;
    this.lastSlide  = this.props.items.length - 2;
  }



  // ===============================================================================================
  scrollToTop(cb) {
    document.querySelector('.swiper-container').scrollIntoView({
      behavior: 'smooth'
    });
    cb();
  }



  // ===============================================================================================
  handleClick(clickedItem) {
    // console.log(`HEADER:\n Clicked ${clickedItem} (${this.props.items[clickedItem].id})`);
    this.props.handleChange(clickedItem);
  }



  // ===============================================================================================
  onClickLeft(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.firstSlide) {
      // console.log(`HEADER:\n Clicked previous slide`);
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide - 1);
      });
    }
  }



  // ===============================================================================================
  onClickRight(e) {
    e.preventDefault();
    if (this.props.activeSlide !== this.lastSlide) {
      // console.log(`HEADER:\n Clicked next slide`);
      this.scrollToTop(() => {
        this.props.handleChange(this.props.activeSlide + 1);
      });
    }
  }



  // ===============================================================================================
  render() {
    return (
      <nav className={"floating-header" +
        ((this.props.hidden) ? " floating-header--hidden" : "")}>

        <div className="floating-header__wrapper">



          <div className="floating-header__left">
            <button
              className={"floating-header__nav-btn floating-header__nav-btn--left" +
                ((this.props.activeSlide === this.firstSlide) ? " floating-header__nav-btn--inactive" : "")}
              tabIndex="-1"
              onClick={this.onClickLeft}>
              <Icon type="nav-left"/>
            </button>
          </div>



          <div className="floating-header__middle">
            <div className="floating-header__list">
              {
                this.navs.map((item) => (
                  <NavListItem
                    key={item.key}
                    id={item.id}
                    title={item.title}
                    current={item.key}
                    active={this.props.activeSlide}
                    handleClick={this.handleClick.bind(this)}
                  />
                ))
              }
            </div>
          </div>



          <div className="floating-header__right">
            <button
              className={"floating-header__nav-btn floating-header__nav-btn--right" +
                ((this.props.activeSlide === this.lastSlide) ? " floating-header__nav-btn--inactive" : "")}
              tabIndex="-1"
              onClick={this.onClickRight}>
              <Icon type="nav-left"/>
            </button>
          </div>



        </div>
      </nav>
    );
  }

}



export default FloatingHeader
